// ============================================================
// RULETA DE PREMIOS
// El premio llega del servicio de premios; la animación solo
// hace que la ruleta se detenga en ese premio.
// ============================================================
import { cfg, fechaCorta, reducido } from "./coco-aniv-nucleo.js";
import { prepararPagina, bloquear, mostrarPremio, imagenPremio, aviso, url } from "./coco-aniv-dinamica.js";
import { sonido, vibrar } from "./coco-aniv-efectos.js";
import { participar, consultar } from "./coco-aniv-premios.js";

const D = cfg.dinamicas.ruleta;
const $ = (s) => document.querySelector(s);
const cta = $("[data-cta]"), ctaTexto = $("[data-cta-texto]");
const PASOS = ["Elige tus joyitas en la tienda.", "En el carrito, escribe tu código en «¿Tienes un cupón?» y verás tu total con el descuento antes de pagar.", `Válido hasta el ${fechaCorta(D.hasta)}.`];

const est = prepararPagina(D);
if (est !== "activo") bloquear(D, est, { imagen: url("img/3d/ruleta.webp") });
else iniciar();

async function iniciar() {
  cta.disabled = true;
  ctaTexto.textContent = "Preparando…";
  const previo = await consultar("ruleta");
  let rueda = null;
  try { rueda = await montar($("[data-escenario]")); } catch (e) { console.warn("Ruleta sin 3D:", e); }
  cta.disabled = false;
  const mostrar = (res, repetido) => mostrarPremio({ premio: res.premio, codigo: res.codigo, imagen: imagenPremio(res.premio), repetido, pasos: PASOS });
  if (previo.ok) {
    rueda?.colocar(previo.premio.id);
    ctaTexto.textContent = "Ver mi premio";
    cta.addEventListener("click", () => mostrar(previo, true));
    return;
  }
  ctaTexto.textContent = D.boton || "Girar ahora";
  $("[data-pista3d]").hidden = false;
  cta.addEventListener("click", async () => {
    cta.disabled = true;
    sonido.boton();
    vibrar(10);
    const res = await participar("ruleta");
    if (!res.ok) { aviso(res.mensaje || "No pudimos girar la ruleta."); cta.disabled = false; return; }
    $("[data-pista3d]").hidden = true;
    if (res.repetido) { mostrar(res, true); cta.disabled = false; return; }
    if (rueda) await rueda.girar(res.premio.id);
    mostrar(res, false);
    ctaTexto.textContent = "Ver mi premio";
    cta.disabled = false;
    cta.onclick = () => mostrar(res, true);
  });
}

async function montar(escenario) {
  const { webglDisponible, escenaViva, animar, curvas, esperar } = await import("./coco-aniv-3d-vivo.js");
  if (!webglDisponible()) return null;
  const { encuadrar, THREE } = await import("./coco-aniv-3d-base.js");
  const { ruleta } = await import("./coco-aniv-3d-ruleta.js");
  await document.fonts.ready;
  const r = await ruleta(D.premios, { repetir: 2 });
  const v = escenaViva(escenario, { fov: 28, alCambiarTamano: () => encuadrar(v.camara, r.grupo, { margen: 0.9, elevacion: 0.07 }) });
  v.escena.add(r.grupo);
  encuadrar(v.camara, r.grupo, { margen: 0.9, elevacion: 0.07 });
  escenario.classList.add("listo");

  // brillo sobre el sector ganador (arriba, donde apunta el corazón)
  const resaltado = new THREE.Mesh(
    new THREE.RingGeometry(0.22, 0.97, 48, 1, Math.PI / 2 - r.paso / 2, r.paso),
    new THREE.MeshBasicMaterial({ color: "#FFF6E8", transparent: true, opacity: 0, blending: THREE.AdditiveBlending, depthWrite: false }),
  );
  resaltado.position.set(0, 0, 0.075);
  r.grupo.add(resaltado);

  let girando = false, a = 0, w = 0, ultimaClavija = null, celebrar = 0;
  const offset = r.paso / 2;
  v.cadaCuadro((dt, t) => {
    if (!girando) r.rueda.rotation.z -= dt * 0.06; // giro lento de espera
    r.grupo.rotation.y = Math.sin(t * 0.6) * 0.05;
    // clavijas que pasan bajo el puntero → tic y golpecito
    const u = Math.floor((r.rueda.rotation.z + offset) / r.paso);
    if (ultimaClavija !== null && u !== ultimaClavija && girando) {
      sonido.tic();
      w += (u < ultimaClavija ? 1 : -1) * 7; // giro horario empuja la punta hacia la derecha
    }
    ultimaClavija = u;
    w += (-260 * a - 16 * w) * dt;
    a = Math.max(-0.55, Math.min(0.55, a + w * dt));
    r.puntero.rotation.z = a;
    // focos: persecución al girar, titileo suave en espera, destellos al ganar
    r.focos.forEach((f, i) => {
      const fase = girando ? Math.sin(t * 16 - i * 0.9) : celebrar > 0 ? Math.sin(t * 20) : Math.sin(t * 2.2 + i * 1.3);
      f.material.emissiveIntensity = 0.7 + 1.1 * (0.5 + 0.5 * fase);
    });
    if (celebrar > 0) celebrar -= dt;
  });

  const colocar = (id) => {
    const i = r.segmentos.findIndex((s) => s.id === id);
    if (i >= 0) r.rueda.rotation.z = i * r.paso;
  };

  async function girar(id) {
    const candidatos = r.segmentos.map((s, i) => (s.id === id ? i : -1)).filter((i) => i >= 0);
    const k = candidatos[(Math.random() * candidatos.length) | 0];
    const base = k * r.paso + (Math.random() - 0.5) * r.paso * 0.6;
    const r0 = r.rueda.rotation.z;
    const vueltas = reducido() ? 1 : D.vueltas || 6;
    const limite = r0 - vueltas * Math.PI * 2;
    const objetivo = base - Math.PI * 2 * Math.ceil((base - limite) / (Math.PI * 2));
    girando = true;
    sonido.whoosh();
    // anticipación: retrocede un poquito antes de arrancar
    await animar(420, (p) => (r.rueda.rotation.z = r0 + 0.22 * Math.sin(p * Math.PI * 0.5)), curvas.salida);
    const r1 = r.rueda.rotation.z;
    await animar(reducido() ? 1200 : D.duracionGiro || 6200, (p) => (r.rueda.rotation.z = r1 + (objetivo - r1) * p), curvas.salidaFuerte);
    girando = false;
    celebrar = 1.6;
    // el sector ganador brilla tres veces
    await animar(1100, (p) => (resaltado.material.opacity = 0.55 * Math.abs(Math.sin(p * Math.PI * 3))), curvas.lineal);
    resaltado.material.opacity = 0.32;
    await esperar(180);
  }
  return { girar, colocar };
}
